import PrivateLayout from './privateLayout';

export * from './types';
export default PrivateLayout;
